import React from "react";
import { SideMenu, EarningChart, StudentChart } from "./../../components";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { BsArrowRight } from "react-icons/bs";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import EnrolledIcon from "./../../../assets/svg/enrolled.svg";
import ActiveCourseIcon from "./../../../assets/svg/activeCourse.svg";
import CompletedCourseIcon from "./../../../assets/svg/completedCourse.svg";
import CoursesInstructorIcon from "./../../../assets/svg/courseInstructor.svg";
import "./student-panel-dashboard.css";
import TableImage from "./../../../assets/images/profileImage.jpg";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 7,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#663399" : "#C4C4C4",
  },
}));
const Dashboard = () => {
  const [selectedEvent, setSelectedEvent] = React.useState(0);
  const [value, onChange] = React.useState(new Date());
  const [courseButton, setCourseButtton] = React.useState("All");
  const EventList = [
    {
      title: "English Class",
      subTitle: "3rd Lesson",
      time: "18:00 - 19:30",
    },
    {
      title: "Maths Class",
      subTitle: "1st Lesson",
      time: "11:00 - 12:30",
    },
    {
      title: "Maths Class",
      subTitle: "2nd Lesson",
      time: "01:00 - 02:30",
    },
    {
      title: "Science",
      subTitle: "1st Lesson",
      time: "03:00 - 05:30",
    },
    {
      title: "English Class",
      subTitle: "2nd Lesson",
      time: "06:00 - 07:30",
    },
  ];
  const CourseTable = [
    {
      percentage: 25,
    },
    {
      percentage: 50,
    },
    {
      percentage: 40,
    },
    {
      percentage: 25,
    },
    {
      percentage: 45,
    },
  ];
  return (
    <SideMenu>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
            <div className="dashboard-first-section">
              <h1 className="dashboard-heading">Hello, David Anderson</h1>
              <div className="dashboard-earning-button-main">
                <Button className="dashboard-earning-button" variant="text">
                  <div className="dashboard-earning-button-icon">
                    <img src={EnrolledIcon} />
                  </div>
                  <div className="dashboard-earning-button-data">
                    <p className="dashboard-earning-button-heading">
                      Enrolled Courses
                    </p>
                    <p className="dashboard-earning-button-price">957</p>
                  </div>
                </Button>
                <Button className="dashboard-booking-button" variant="text">
                  <div className="dashboard-earning-button-icon">
                    <img src={ActiveCourseIcon} />
                  </div>
                  <div className="dashboard-earning-button-data">
                    <p className="dashboard-booking-button-heading">
                      Active Courses
                    </p>
                    <p className="dashboard-earning-button-price">6</p>
                  </div>
                </Button>
              </div>
              <div className="dashboard-earning-button-main">
                <Button
                  className="dashboard-completed-course-button"
                  variant="text"
                >
                  <div className="dashboard-earning-button-icon">
                    <img src={CompletedCourseIcon} />
                  </div>
                  <div className="dashboard-earning-button-data">
                    <p className="dashboard-completed-course-button-heading">
                      Complated Courses
                    </p>
                    <p className="dashboard-earning-button-price">951</p>
                  </div>
                </Button>
                <Button className="dashboard-booking-button" variant="text">
                  <div className="dashboard-earning-button-icon">
                    <img src={CoursesInstructorIcon} />
                  </div>
                  <div className="dashboard-earning-button-data">
                    <p className="dashboard-booking-button-heading">
                      Courses Instructor
                    </p>
                    <p className="dashboard-earning-button-price">241</p>
                  </div>
                </Button>
              </div>
              <div className="dashboard-box-main">
                <div className="dashboard-chart-header">
                  <h1 className="dashboard-box-heading">
                    Total Learning Time - 72h 28m
                  </h1>
                  <select className="dashboard-filter-drowpdown">
                    <option>Weekly</option>
                    <option>Monthly</option>
                    <option>Yearly</option>
                  </select>
                </div>
                <div className="dashboard-chart-main">
                  <EarningChart />
                </div>
              </div>
              <div className="analytics-graph-main">
                <div className="graph-filter-main">
                  <p className="analytics-graph-heading">My Activity</p>
                  <div className="analytics-graph-filter-header">
                    <p className="analytics-graph-header-date">Jan-2022</p>
                    <select className="analytics-graph-filter-dropdown">
                      <option value="Monthly">Monthly</option>
                      <option value="Weekely">Weekely</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <StudentChart />
              </div>
              <br />
              <div className="student-panel-dashboard-table-container">
                <div className="student-panel-dashboard-table-header">
                  <h1 className="student-panel-dashboard-table-header-heading">
                    My Course
                  </h1>
                  <div>
                    <Button onClick={() => setCourseButtton("All")}>
                      <p
                        className={
                          courseButton === "All"
                            ? "student-panel-dashboard-table-header-active_button"
                            : "student-panel-dashboard-table-header-button"
                        }
                      >
                        All
                      </p>
                    </Button>
                    <Button onClick={() => setCourseButtton("Ongoing")}>
                      <p
                        className={
                          courseButton === "Ongoing"
                            ? "student-panel-dashboard-table-header-active_button"
                            : "student-panel-dashboard-table-header-button"
                        }
                      >
                        Ongoing
                      </p>
                    </Button>
                    <Button onClick={() => setCourseButtton("Complated")}>
                      <p
                        className={
                          courseButton === "Complated"
                            ? "student-panel-dashboard-table-header-active_button"
                            : "student-panel-dashboard-table-header-button"
                        }
                      >
                        Complated
                      </p>
                    </Button>
                  </div>
                </div>
                <div className="student-panel-dashboard-table-data-container">
                  <table>
                    {CourseTable.map((courseTableValue, courseTableIndex) => {
                      return (
                        <tr key={courseTableIndex}>
                          <td className="student-panel-dashboard-table-image-main">
                            <img
                              src={TableImage}
                              className="student-panel-dashboard-table-image"
                            />
                          </td>
                          <td className="student-panel-dashboard-table-description-main">
                            <p className="student-panel-dashboard-table-description">
                              Phasellus dapibus, arcu at porta euismod
                            </p>
                            <p className="student-panel-dashboard-table-username">
                              by Willow Anderson
                            </p>
                          </td>
                          <td className="student-panel-dashboard-table-progress-main">
                            <div className="student-panel-dashboard-table-progress-data-main">
                              <p className="student-panel-dashboard-table-progress-percentage">
                                {courseTableValue.percentage}%
                              </p>
                              <div className="student-panel-dashboard-table-progress-bar">
                                <BorderLinearProgress
                                  variant="determinate"
                                  value={courseTableValue.percentage}
                                />
                              </div>
                            </div>
                          </td>
                          <td className="student-panel-dashboard-table-button-main">
                            <Button className="student-panel-dashboard-table-view-button">
                              View Course
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
            <div className="dashboard-second-section">
              <div>
                <Calendar onChange={onChange} value={value} />
              </div>
              <div className="dashboard-upcomming-class-main">
                <p className="dashboard-upcomming-class-heading">
                  Upcomming task
                </p>
                <Button
                  className="dashboard-upcomming-class-see-all-button"
                  variant="text"
                >
                  <p className="dashboard-upcomming-class-see-all-title">
                    see all
                  </p>
                  <BsArrowRight color="#303030" size={30} />
                </Button>
              </div>
              {EventList.map((eventValue, eventIndex) => {
                return (
                  <Button
                    className={
                      selectedEvent === eventIndex
                        ? "upcomming-class-selected-card"
                        : "upcomming-class-un-selected-card"
                    }
                    variant="text"
                    key={eventIndex}
                    onClick={() => setSelectedEvent(eventIndex)}
                  >
                    <div className="upcomming-class-card-list-main">
                      <p
                        className={
                          selectedEvent === eventIndex
                            ? "upcomming-class-selected-card-title"
                            : "upcomming-class-un-selected-card-title"
                        }
                      >
                        {eventValue.title}
                      </p>
                      <p
                        className={
                          selectedEvent === eventIndex
                            ? "upcomming-class-selected-card-sub-title"
                            : "upcomming-class-un-selected-card-sub-title"
                        }
                      >
                        {eventValue.subTitle}
                      </p>
                    </div>
                    <p
                      className={
                        selectedEvent === eventIndex
                          ? "upcomming-class-selected-card-time"
                          : "upcomming-class-un-selected-card-time"
                      }
                    >
                      {eventValue.time}
                    </p>
                  </Button>
                );
              })}
            </div>
          </Grid>
        </Grid>
      </Box>
    </SideMenu>
  );
};
export default Dashboard;
